import instance from "./axios";
import {
  StringPeelType,
  StringPeelPostPayload,
} from "../types/stringPeelTypes";

export const postStringPeel = async (data: StringPeelPostPayload) => {
  const response = await instance.post("/v1.0/Material/AddStringPeel", data);
  return response.data;
};

export const fetchLastStringPeel = async (): Promise<StringPeelType[]> => {
  const response = await instance.get<StringPeelType[]>(
    `/v1.0/Material/GetLastStringPeel?num=10`
  );
  return Array.isArray(response.data) ? response.data : [response.data as any];
};
